import React, { useState } from 'react';
import './WitchQuiz.css';

const questions = [
  { question: "What time of day do you feel most energized?", options: ["Sunrise", "Midday", "Sunset", "Midnight"], points: [1, 2, 3, 4] },
  { question: "Which element do you feel drawn to?", options: ["Earth", "Water", "Fire", "Air"], points: [2, 3, 4, 5] },
  { question: "Choose your ideal place:", options: ["Deep forest", "Seaside", "Cozy kitchen", "The comfort of your room"], points: [3, 2, 1, 5] },
  { question: "How do you make difficult decisions?", options: ["Based on your horoscope", "Based on how you feel in the moment", "The most logical option", "Thinking it through while doing something that grounds you"], points: [5, 3, 2, 4] },
  { question: "Favorite summer activity?", options: ["Beach rotting", "Camping and barbecue", "New summer recipes", "Reading and journaling in a cute cafe"], points: [2, 3, 1, 4] },
  { question: "Pick a season", options: ["Spring", "Summer", "Autumn", "Winter"], points: [2, 3, 4, 5] },
  { question: "What's your power?", options: ["Healing", "Read minds", "Transformation", "See the future"], points: [1, 2, 4, 5] },
  { question: "What hypes you up the most?", options: ["A good day out in nature", "A delicious meal", "Music", "Your friends"], points: [3, 1, 5, 2] },
  { question: "What colors call to you?", options: ["Greens and browns (earth tones)", "Blues and silvers", "Reds and oranges", "Blacks and purples"], points: [2, 3, 4, 5] },
  { question: "What do you value?", options: ["Comfort and home, a sense of safety", "Connection with nature", "Knowledge and clarity", "Power and ambition"], points: [1, 2, 5, 4] },
  { question: "How do you recharge?", options: ["A warm bath and nice dinner", "A long walk", "Working out", "A night out with your friends"], points: [1, 2, 3, 5] },
  { question: "What ancient symbol would you wear?", options: ["Spiral, representing growth and journey", "The Triskele, representing the cycles of life", "The Pentacle, bringing protection", "The Eye, symbolizing intuition"], points: [2, 3, 4, 5] },
  { question: "Go-to book?", options: ["Romance novel", "Nature books", "Horror", "Nonfiction"], points: [1, 2, 3, 4] },
];

function Quiz() {
  const [currentQ, setCurrentQ] = useState(0);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const handleAnswer = (points) => {
    setScore((s) => s + points);
    const next = currentQ + 1;
    if (next < questions.length) setCurrentQ(next);
    else setShowResult(true);
  };

  const getResult = () => {
    if (score >= 10 && score <= 21) return "Green Witch";
    else if (score >= 22 && score <= 30) return "Forest Witch";
    else if (score >= 31 && score <= 40) return "Fire Witch";
    else if (score >= 41 && score <= 50) return "Lunar Witch";
    else return "Cosmic Witch";
  };

  return (
    <div className="witchquiz-page">
    <div className="quiz-container">
      <h1 className="quiz-title">What Kind of Witch Are You?</h1>

      {showResult ? (
        <div className="result">
          <h2 className="result-title">You are a: <span className="result-badge">{getResult()}</span></h2>
        </div>
      ) : (
        <>
          <h2 className="question">{questions[currentQ].question}</h2>
          <div className="options">
            {questions[currentQ].options.map((opt, index) => (
              <button
                className="option-btn"
                onClick={() => handleAnswer(questions[currentQ].points[index])}
                key={index}
              >
                {opt}
              </button>
            ))}
          </div>
          <div className="progress" aria-live="polite">
            Question {currentQ + 1} of {questions.length}
          </div>
        </>
      )}
    </div>
    </div>
  );
}

export default Quiz;
